import {FungusRecordField} from "@/config/config-fungus";

/**
 * Takes the complex config file used for user input and transforms it to simple key-value
 * object in such a way that it can be submitted to the server.
 * @param fungusRecordForm
 */

export const toUrlParams = function (fungusRecordForm: { site: FungusRecordField[], records: FungusRecordField[][] }) {
    const result = {} as any // Here goes the configless data
    result.records = fungusRecordForm.records.map(record => simplifyRecord(record)) // Funde
    Object.assign(result, simplifySite(fungusRecordForm.site)) // Fundort
    return result
}

function simplifySite(site: FungusRecordField[]) {
    const result = {} as any
    site.forEach((field: FungusRecordField) => result[field.name] = field.value)

    result.x = result.coords[0]
    result.y = result.coords[1]

    return result
}


function simplifyRecord(fungusRecord: FungusRecordField[]) {
    const result = {} as any
    fungusRecord.forEach((field: FungusRecordField) => result[field.name] = field.value)
    result.specimens = result.specimens.map((spec: FungusRecordField[]) => simplifySpecimen(spec))

    // special taxon handling for complex entities
    result.taxonReferenceSuggested = {
        'ifFlorAppReferenceWork': result.taxonReferenceSuggested.find((field: FungusRecordField) => field.name === 'ifFlorAppReferenceWork').value,
        'taxonId': result.taxonReferenceSuggested.find((field: FungusRecordField) => field.name === 'taxonId').value,
        'suggestedTaxonName': result.taxonReferenceSuggested.find((field: FungusRecordField) => field.name === 'suggestedTaxonName').value,
        'suggestedTaxonPublication': result.taxonReferenceSuggested.find((field: FungusRecordField) => field.name === 'suggestedTaxonPublication').value,
        // 'suggestedTaxonDescription': result.taxonReferenceSuggested.find((field: FungusRecordField) => field.name === 'suggestedTaxonDescription').value,
        'suggestedTaxonComment': result.taxonReferenceSuggested.find((field: FungusRecordField) => field.name === 'suggestedTaxonComment').value,
    }

    result.images = JSON.parse(JSON.stringify(result.images))

    return result
}


function simplifySpecimen(specimen: FungusRecordField[]) {
    let result = {} as any
    if (specimen.constructor.name == "Array") {
        // for new specimens that are populated using the config structure
        specimen.forEach((field: FungusRecordField) => result[field.name] = field.value)
    } else {
        result = specimen
    }
    return result
}


